import { IGeoValue } from '../types';
import { useCallback, useMemo } from 'react';
import { ITagOption } from '@cian/ui-kit/tags/types/ITagOption';

export interface IUserTagsProps {
  geoValues: IGeoValue[];

  onGeoValuesChange(values: IGeoValue[]): void;
}

export const useTags = ({ geoValues, onGeoValuesChange }: IUserTagsProps) => {
  const tags = useMemo<ITagOption[]>(
    () =>
      geoValues.map(({ title }) => ({
        value: title,
        label: title,
      })),
    [geoValues],
  );

  const onCloseTag = useCallback(
    (tag: ITagOption) => onGeoValuesChange(geoValues.filter(value => value.title !== tag.value)),
    [geoValues, onGeoValuesChange],
  );

  return {
    tags,
    onCloseTag,
  };
};
